import styled from 'styled-components';

import LogoMarkSvg from '../../../assets/logos/logo-mark.svg?react';

import { RegistrationCompleteDonationCard } from './registration-complete-donation-card';
import { RegistrationCompleteFeedbackCard } from './registration-complete-feedback-card';
import { RegistrationCompleteProfileSummaryCard } from './registration-complete-profile-summary-card';

type RegistrationCompletePreviewVariant = 'with-photo' | 'without-photo';

type RegistrationCompleteProfilePreviewProps = {
  previewVariant: RegistrationCompletePreviewVariant;
};

const PreviewSurface = styled.div.attrs({
  'data-ui': 'registration-complete-profile-preview',
})`
  width: ${({ theme }) => theme.scale.px(293)};
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.surface.preview};
  border-radius: ${({ theme }) => theme.scale.px(16)};
  padding: ${({ theme }) => theme.scale.px(39)}
    ${({ theme }) => theme.scale.px(25)} ${({ theme }) => theme.scale.px(30)};
  display: grid;
  grid-template-columns: 1fr;
  justify-items: center;
  align-content: start;
  gap: ${({ theme }) => theme.scale.px(8)};
`;

const BrandLogo = styled(LogoMarkSvg).attrs({
  'aria-hidden': true,
  focusable: 'false',
})`
  width: ${({ theme }) => theme.scale.px(74)};
  height: ${({ theme }) => theme.scale.px(22)};
  display: block;
  color: ${({ theme }) => theme.colors.text.primary};
  --logo-mark-accent: ${({ theme }) => theme.colors.brand.primary};
`;

export function RegistrationCompleteProfilePreview({
  previewVariant,
}: RegistrationCompleteProfilePreviewProps) {
  return (
    <PreviewSurface>
      <BrandLogo />
      <RegistrationCompleteProfileSummaryCard previewVariant={previewVariant} />
      <RegistrationCompleteDonationCard />
      <RegistrationCompleteFeedbackCard />
    </PreviewSurface>
  );
}
